var _ellipse, _ellipse2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 121,
    viewBox: "0 0 170 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.5947,
    cy: 83.5032,
    rx: 60,
    ry: 16,
    transform: "rotate(-22.2215 96.5947 83.5032)",
    fill: "#6CB2FF",
    fillOpacity: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.3631,
    cy: 10.8032,
    rx: 84.3631,
    ry: 10.8032,
    transform: "matrix(-0.982235 -0.187657 -0.187657 0.982235 169.785 94.6641)",
    fill: "#6CB2FF",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3783 75.8462C72.565 90.1231 88.9834 93.0975 96.4193 92.8C104.45 91.0154 119.025 86.5539 122.594 66.6257C125.449 50.6831 120.413 40.5504 117.538 37.4769C122.16 46.1026 117.24 57.1077 112.481 55.0257C107.722 52.9436 109.507 45.8051 112.481 32.1231C114.861 21.1774 107.326 13.4838 103.261 11.0051C105.64 19.8092 100.881 26.571 98.2043 28.8513C100.822 10.5292 91.3633 1.98291 86.3069 0C89.083 4.1641 91.7797 16.0615 80.3582 30.3385C68.9366 44.6154 71.6334 55.918 74.4095 59.7846C67.271 53.8359 68.4605 45.2103 69.9475 41.641C66.0809 46.9949 58.645 58 66.3783 75.8462Z",
    fill: "url(#paint0_linear_4706_22805)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8984 69.6008C76.3743 85.7813 90.1754 91.2145 97.0164 91.9085C112.483 87.8633 114.367 71.5837 113.375 63.9495C111.472 69.4223 107.03 71.9803 105.047 72.5751C111.472 57.1085 104.155 45.3102 99.6933 41.3444C103.263 49.9105 101.181 55.423 99.6933 57.1085C90.8892 54.0151 88.0933 42.3358 87.7959 36.8828C76.3743 51.8736 83.0369 69.6999 87.7959 76.7392C81.6092 75.3115 77.2865 71.3854 75.8984 69.6008Z",
    fill: "#2798FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.937 82.0957C92.7955 87.5685 88.6909 84.376 86.9062 82.0957C86.9062 91.0188 91.6652 91.0188 96.4242 91.6136C101.183 92.2085 106.537 80.0136 97.9114 73.1726C91.0109 67.6998 87.6994 59.5897 86.9062 56.2188C86.9062 57.5076 87.2632 61.4536 88.6909 66.9264C90.4755 73.7675 97.6139 75.2547 94.937 82.0957Z",
    fill: "url(#paint1_linear_4706_22805)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4706_22805",
    x1: 93.221,
    y1: 0,
    x2: 93.221,
    y2: 92.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B34A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1676F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4706_22805",
    x1: 94.6978,
    y1: 91.6346,
    x2: 94.6978,
    y2: 56.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66DCFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.69d91966f85f4b1b8899b7c8e48dfdd0.svg";
export { ForwardRef as ReactComponent };